export const relatedSearchTerms: Record<string, string[]> = {
  sweat: ["sweatshirt", "hoodie", "tracksuit", "sweat pants", "jumper"],
  hoodie: ["sweatshirt", "sweat", "tracksuit", "fleece"],
  optus: ["smartphone", "prepaid sim", "phone case", "4g phone"],
  uno: ["card games", "board games", "playing cards", "family games"],
  offers: ["clearance", "low price", "sale"],
  easter: ["easter eggs", "baskets", "craft"],
};

export function getRelatedSearchTerms(query: string): string[] {
  const key = query.trim().toLowerCase();
  return relatedSearchTerms[key] ?? [];
}

export const searchSuggestions = [
  "sweatshirt",
  "hoodie",
  "air fryer",
  "toys",
  "optus phone",
];
